module.exports = __webpack_public_path__ + "img/scross-glx-negro.c0e40096.png";